import React from 'react';

// ----------------------------------------------------------------------

import CommonDelete from '@common/CommonDelete';
import Store from '@data/Store';
import { deleteSquadByIdService } from '../squad.services';

// ----------------------------------------------------------------------

export const SquadDelete = ({ closeModal, id, message }) => {
  const { language } = Store;

  const handleDelete = () => {
    deleteSquadByIdService({ id }).then(() => {
      closeModal();
    });
  };

  return (
    <CommonDelete
      language={language}
      closeModal={closeModal}
      onDelete={handleDelete}
      message={message}
    />
  );
};

export default SquadDelete;
